import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
export const TimerColor = new Enum(['TIMER_COLOR_DO_NOT_USE', 'YELLOW', 'RED']);

// Remote device settings for point of sale devices
export default ProtoBaseModel.extend({
  timerEnabled: attr(Boolean),
  fireInterval: attr(Number),
  color: attr(TimerColor)
});